"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = void 0;

var throttle = function throttle(callback, limit) {
  var lastCallback;
  var lastRan;
  return function () {
    for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
      rest[_key] = arguments[_key];
    }

    var now = Date.now();

    if (!lastRan) {
      callback(rest);
      lastRan = now;
    } else {
      clearTimeout(lastCallback);
      lastCallback = setTimeout(function () {
        if (now - lastRan >= limit) {
          callback(rest);
          lastRan = now;
        }
      }, limit - (now - lastRan));
    }
  };
};

exports.throttle = throttle;